import React, { useState, useEffect } from "react";
import {
  FormGroup,
  FormInput,
  Row,
  Col,
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  UNMOUNTED,
} from "shards-react";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import {
  SelectAgencyPowerBi,
  SelectIndicatorsDatasetKeyin,
  SelectIndicatorsDatasetKeyinTabs,
  SelectYears,
} from "shared/components";
import { Loading } from "views/PowerbiSetting/components";
import useCurrentUser from "shared/hook/useCurrentUser";

const RowData = styled(Row)`
  margin-top: 10px;
  border-top: 1px solid #e1e5eb;
  padding-top: 20px;
`;

const showNotify = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "error":
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "warn":
      toast.warn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "info":
      toast.info(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    default:
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
  }
};

const PowerbiSettingUploadfile = (props) => {
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [userType, setUserType] = useState(0);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [agencyId, setAgencyId] = useState(null);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [dataForCreate, setDataForCreate] = useState(null);
  const [indicatorsDatasetName, setIndicatorsDatasetName] = useState(null);
  const [tableTabSettingId, setTableTabSettingId] = useState(null);
  const [fileUpload, setFileUpload] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [tableHeadId, setTableHead] = useState(null);

  const axios = require("axios").default;
  const FormData = require("form-data");

  const tableTabMasterId = [
    5,
    15,
    16,
    22,
    32,
    37,
    38,
    39,
    64,
    67,
    72,
    93,
    98,
    99,
    108,
    109,
  ];

  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = (dataImport, path) => {
    if (indicatorsDatasetId == 30) {
      var data = JSON.stringify({
        indicatorsDatasetSettingId: indicatorsDatasetId,
        agencyId: agencyId,
        tableTabSettingId: tableTabSettingId,
        yearId: dataImport[0].yearId == undefined ? null : dataImport[0].yearId,
        create: dataImport,
        tableHeadId: tableHeadId || null,
        importPath : `${baseUrl}/${path}`
      });
    } else {
      var data = JSON.stringify({
        indicatorsDatasetSettingId: indicatorsDatasetId,
        agencyId: agencyId,
        tableTabSettingId: tableTabSettingId,
        yearId: dataImport[0].yearId == undefined ? indicatorsDatasetId == 17 ? null : 1 : dataImport[0].yearId,
        create: dataImport,
        importPath : `${baseUrl}/${path}`
      });
    }

    var config = {
      method: "post",
      url: `${baseUrl}/v1/table${indicatorsDatasetId}/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        console.log(
          `${baseUrl}/v1/table${indicatorsDatasetId}/create`,
          response.data
        );
        setAgencyId(0);
        setIndicatorsDatasetId(0);
        setIndicatorsDatasetName(null);
        setTableTabSettingId(0);
        setSelectedFile(null);
        setLoading(false);

        showNotify(`แจ้งเตือน! บันทึกข้อมูลเรียบร้อย`);
      })
      .catch(function(error) {
        console.log(`${baseUrl}/v1/table${indicatorsDatasetId}/create`, error);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
        setSelectedFile(null);
        setLoading(false);
      });
  };
  //3 อ่านไฟล์วาด object
  const onImportTable = (file) => {
    var data = JSON.stringify({
      path: file.path,
      tableTabSettingId: tableTabSettingId,
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/table${indicatorsDatasetId}/import`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        if (indicatorsDatasetId == 30) {
          setDataForCreate(response.data.tableData);
          onCeateTable(response.data.tableData, file.path);
          setTableHead(
            response.data.tableHead != null
              ? response.data.tableHead.tableHeadId
              : null
          );
          showNotify(
            `แจ้งเตือน! จำนวนข้อมูลที่นำเข้าทั้งหมด ${response.data.tableData.length} แถว`
          );
        }
        if(indicatorsDatasetId == 17){
          onCeateTable(response.data, file.path);
        }
        else {
          setDataForCreate(response.data);
          showNotify(
            `แจ้งเตือน! จำนวนข้อมูลที่นำเข้าทั้งหมด ${response.data.length} แถว`
          );
          if (tableTabMasterId.indexOf(Number(tableTabSettingId)) == -1) {
            onCeateTable(response.data, file.path);
          } else {
            setAgencyId(0);
            setIndicatorsDatasetId(0);
            setIndicatorsDatasetName(null);
            setTableTabSettingId(0);
            setSelectedFile(null);
            setLoading(false);
            showNotify(`แจ้งเตือน! บันทึกข้อมูลเรียบร้อย`);
          }
        }
      })
      .catch(function(error) {
        setSelectedFile(null);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
        setLoading(false);
      });
  };
  //1
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  //2 อัพโหลดไฟล์
  const onFileChange = (fileUpload) => {
    var data = new FormData();
    data.append("file", fileUpload);
    var config = {
      method: "post",
      url: `${baseUrl}/v1/upload`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        console.log("/upload", response.data);
        setFileUpload(response.data);
        onImportTable(response.data);
      })
      .catch(function(error) {
        console.log("/upload error", error);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectedFile != null) {
      setLoading(true);
      console.log("/selectedFile", selectedFile);
      onFileChange(selectedFile);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (curruntUser) {
      setUserType(curruntUser.detail.userType);
      setAgencyId(curruntUser.detail.agencyId);
      setUserId(curruntUser.detail.userId);
    }
  }, [curruntUser]);

  return (
    <Layout>
      {loading && <Loading message="กำลังนำเข้าข้อมูล..." />}
      <ToastContainer />

      <Row>
        <Col md="12">
          <h5 style={{ marginBottom: "30px" }}>อัพโหลดไฟล์ (Upload file)</h5>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <label>
              หน่วยงานเจ้าของข้อมูล<span style={{ color: "red" }}>*</span>
            </label>
            <SelectAgencyPowerBi
              placeholder="เลือก"
              name="agencyId"
              onChange={(e) => {
                setAgencyId(e.target.value);
                setIndicatorsDatasetId(0);
              }}
              defaultValue={agencyId}
              value={agencyId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>
              ข้อมูล/ตัวชี้วัด<span style={{ color: "red" }}>*</span>
            </label>
            <SelectIndicatorsDatasetKeyin
              placeholder="เลือก"
              disabled={agencyId == null || agencyId == 0}
              name="indicatorsDatasetId"
              onChange={(e) => {
                setIndicatorsDatasetId(e.target.value);
                setIndicatorsDatasetName(
                  e.target.options[e.target.selectedIndex].text
                );
                setTableTabSettingId(0);
              }}
              agencyId={agencyId}
              defaultValue={indicatorsDatasetId}
              value={indicatorsDatasetId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ชื่อชุดข้อมูล</label>
            <SelectIndicatorsDatasetKeyinTabs
              placeholder="เลือก"
              name="indicatorsDatasetSettingId"
              disabled={
                agencyId == null ||
                indicatorsDatasetId == null ||
                agencyId == 0 ||
                indicatorsDatasetId == 0
              }
              onChange={(e) => {
                setTableTabSettingId(e.target.value);
              }}
              agencyId={agencyId}
              indicatorsDatasetSettingId={indicatorsDatasetId}
              defaultValue={tableTabSettingId}
              value={tableTabSettingId}
            />
          </FormGroup>
        </Col>
      </Row>

      {/* start data */}
      {indicatorsDatasetId != null &&
      indicatorsDatasetId != 0 &&
      agencyId != null &&
      agencyId != 0 &&
      tableTabSettingId != 0 &&
      tableTabSettingId != null ? (
        <RowData>
          <Col md="12">
            <h6 style={{ marginBottom: "30px" }}>
              <b>ข้อมูล/ตัวชี้วัด: </b>
              {indicatorsDatasetName}
            </h6>
            <p>
              ดาวน์โหลดไฟล์มาตรฐานเพื่อใช้ในการกรอกข้อมูล
              <div>
                <a
                  href={require(`shared/assets/template/${indicatorsDatasetId}import-${tableTabSettingId}.xlsx`)}
                  download
                >
                  <Button theme="success">คลิกเพื่อดาวน์โหลด</Button>
                </a>
              </div>
            </p>
          </Col>
          <Col md="12">
            <input type="file" name="file" onChange={changeHandler} />
          </Col>
        </RowData>
      ) : (
        <RowData>
          <Col md="12">
            <p style={{ textAlign: "center" }}>
              กรุณาเลือก ตัวชี้วัด ที่ต้องการนำเข้าข้อมูล{" "}
            </p>
          </Col>
        </RowData>
      )}
    </Layout>
  );
};

export default PowerbiSettingUploadfile;
